
import { Component, Vue } from 'vue-property-decorator';
import AdminUserTable from '@/active-components/admin/AdminUserTable.vue';
import AdminEventTable from '@/active-components/admin/AdminEventTable.vue';
import AdminDocuments from '@/active-components/admin/AdminDocuments.vue';

const tabNames = ['events', 'users', 'documents'];

@Component({
    components: {
        AdminUserTable,
        AdminEventTable,
        AdminDocuments,
    },
})
export default class Admin extends Vue {
    get activeTab(): number {
        const { tab } = this.$route.query;
        const tabName = Array.isArray(tab) ? tab[0] : tab;
        const tabIndex = tabNames.indexOf(tabName);

        return Math.max(tabIndex, 0);
    }

    set activeTab(tabIndex: number) {
        this.onTabChange(tabIndex);
    }

    onTabChange(tabIndex: number): void {
        const tab = tabNames[tabIndex];

        if (!tab) {
            return;
        }

        this.$router.replace({
            query: {
                ...this.$route.query,
                tab,
            },
        });
    }
}
